import * as SkylineAPI from "../skylineApi"
import * as adminFeed from "../adminFeed"
import { bindData } from "../utils"

export default class RadioList {
  constructor(root, options) {
    this.root = root
    this.options = options

    this.template = this.root.getElementsByTagName("template")[0].content.firstElementChild
    if (this.options.single) {
      //const shadow = this.attachShadow({mode:"open"})
      this.selector = this.root.querySelector(".selector")
      if (!this.selector) {
        this.selector = document.createElement("div")
        this.selector.className = "selector"
        this.root.appendChild(this.selector)
      }
    } else {
      this.selector = this.root
    }

    let devices = Object.values(SkylineAPI.getDevices())
    
    for (const device of devices) {
      this.processDevice({action:"CREATE", device})
    }

    this.feedHandler = (ev) => {
      this.processDevice(ev)
    }
    this.feedHandler = this.feedHandler.bind(this)
    adminFeed.register("device", this.feedHandler)

    if (this.options.single) {
      const placeholder = this.root.getElementsByClassName("placeholder")
      if (placeholder.length > 0) this.placeholder = placeholder[0]
      this.root.addEventListener("click", () => {
        this.root.classList.toggle("radio-selecting")
        this.selector.classList.toggle("visible")
        this.selector.style.top = `${this.root.querySelector(".airborne").getBoundingClientRect().height}px`
      })
    }
  }

  processDevice(ev) {
    let E = this.root.querySelector(`[data-did='${ev.device.id}']`)
    if (ev.action === "DELETE") {
      // It's out, remove it
      if (E) this.selector.removeChild(E)
      return
    }
    
    if (this.options.type && ev.device.type !== this.options.type) return

    if (this.options.filterReady) {
      if (!E) {
        if (ev.device.state === "STANDBY") {
          // Add the node that is now ready in standby mode
          E = this.createNode(ev.device)
        } else {
          // Bail because we don't need to know about this node
          return
        }
      }
      if (E && ev.device.state !== "STANDBY") {
        // Remove because the device is no longer ready
        return this.selector.removeChild(E)
      }
    }
    // Rebind our data for the basic update
    if (!ev.device) {
      console.log("Bad ev", ev)
    }
    if (!E && ev.action === "CREATE") {
      E = this.createNode(ev.device)
    }
    bindData(ev.device, E)
    E.device = ev.device
  }

  createNode(device) {
    const node = this.template.cloneNode(true)
    node.device = device
    if (this.options.selectable) {
      node.addEventListener("click", (ev) => {
        if (this.options.single) {
          this.placeholder.style.display = "none"
          const parent = this.root.querySelector(".selected")
          while (parent.firstElementChild) {
            parent.removeChild(parent.firstElementChild)
          }
          parent.appendChild(node.cloneNode(true))
          this.root.classList.add("airborne-selected")
        } else {
          node.classList.toggle("radio-selected")
        }
        if (this.options.selectCallback) {
          this.options.selectCallback(device)
        }
      })
    }
    node.dataset.did = device.id
    bindData(device, node)
    const img = node.getElementsByTagName("img")[0]
    img.src = device.type === "ARS" ? '/images/Active ARS.png' : '/images/Inactive GRS.png'
    this.selector.appendChild(node)

    return node
  }

  cleanup() {
    adminFeed.unregister("device", this.feedHandler)
  }
}